import { registerCapability } from '../../platform/capability-registry';
import { SystemDiskSizeBlock } from './SystemDiskSizeBlock';
import { SYSTEM_DISK_SIZE_ACTION_KEY_LIST, SYSTEM_DISK_SIZE_FIELD_KEY_LIST } from './fieldKeys';
import { resolveSystemDiskSizePaths } from './resolvePaths';
import type { SystemDiskSizeBlockOptions } from './types';

registerCapability<SystemDiskSizeBlockOptions>({
  key: 'system-disk-size',
  fields: [...SYSTEM_DISK_SIZE_FIELD_KEY_LIST],
  actions: [...SYSTEM_DISK_SIZE_ACTION_KEY_LIST],
  component: SystemDiskSizeBlock,
  defaultPaths: (prefix) => resolveSystemDiskSizePaths(prefix),
  resolvePaths: (prefix, options) => resolveSystemDiskSizePaths(prefix, options),
});
